export default __webpack_public_path__ + "static/media/TourGuidePage_04.1983649c.jpg";